<template>
  <button-action
    :icon="icon"
    :label="label"
    class="button-small"
    @click="$emit('click')"
    ><template v-slot:icon v-if="this.$slots['icon']"
      ><slot name="icon"></slot></template
  ></button-action>
</template>

<script>
import ButtonAction from "@/components/buttons/ButtonAction";

export default {
  name: "ButtonActionSmall",
  components: { ButtonAction },
  props: {
    label: {
      type: String,
      default: "Button"
    },
    icon: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
.button-small {
  background-color: var(--color-button-normal);
  border: none;
  border-radius: 0.5em;
  color: #aaa;
  padding: 0.5em;
  font-size: 1em;
}
.button-small:hover {
  cursor: pointer;
  background-color: var(--color-button-hover);
}
.button-small:active {
  background-color: var(--color-button-active);
}
</style>
